import React from 'react';
import { Box, Typography } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary:', {
      error,
      errorInfo,
      timestamp: new Date().toISOString(),
      type: this.props.type || 'general'
    });
  }

  render() {
    if (this.state.hasError) {
      // If it's an image error boundary
      if (this.props.type === 'image') {
        return (
          <Box sx={{ 
            width: '100%', 
            height: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            bgcolor: 'rgba(0, 0, 0, 0.05)',
            p: 2,
            borderRadius: 1
          }}>
            <Typography color="error">Failed to load image</Typography>
          </Box>
        );
      }

      // General error
      return (
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Typography color="error">
            {this.props.fallback || 'Something went wrong.'}
          </Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;